import React from "react";
import "./bannerMessageFixed.css";

const BannerMessageFixed = ({ type = "info", text, exiting = false }) => {
	if (!text) return null;

	return (
		<div className="sf-fixed-banner-wrap">
			<div
				className={[
					"sf-fixed-banner",
					`sf-fixed-banner--${type}`,
					exiting ? "sf-fixed-banner--exit" : "",
				].join(" ")}
			>
				<span className="sf-fixed-banner-text">{text}</span>
			</div>
		</div>
	);
};

export default BannerMessageFixed;
